"use strict";

$(document).ready(function () {
  console.log(
    "%cWelcome to %cAccoladeIP%c. Developed by %cVisible One%c. (v0.2.1)",
    "background: linear-gradient(to right, red, orange); color: white; padding: 5px;",
    "background: linear-gradient(to right, orange, yellow); color: white; padding: 5px;",
    "background: linear-gradient(to right, yellow, green); color: white; padding: 5px;",
    "background: linear-gradient(to right, green, blue); color: white; padding: 5px;",
    "background: linear-gradient(to right, blue, purple); color: white; padding: 5px;"
  );

  // ! Important to declare global scope to manipulate the state
  window.accolade = window.accolade || {};
  accolade.items = accolade.items || [];
  accolade.trademarks = accolade.trademarks || [];
  accolade.locations = accolade.locations || [];
  accolade.totalPrice = accolade.totalPrice || 0;
  accolade.searchHistory = accolade.searchHistory || [];
  accolade.quantity = accolade.quantity || 0;

  function _simpleUIStuff() {
    $(".step1Next").click(function (event) {
      event.stopPropagation();

      // Remove multiple class
      $("#step1").removeClass("show active");
      $("#step2tab").removeClass("unable");
      $(".step2Prev").removeClass("unable");
      $("#step2").addClass("show active");

      //* Create a map to store unique items based on "id"
      const trademarks = accolade.trademarks;
      const uniqueDataMap = new Map();
      trademarks.forEach((tm) => {
        //* Split the "id" string using "_" as the delimiter and take the first part
        const idWithoutSuffix = tm.id.split("_")[0];

        accolade.quantity = accolade.trademarks.length;

        uniqueDataMap.set(idWithoutSuffix, tm);
      });

      //* Convert the map values back to an array
      const uniqueData = Array.from(uniqueDataMap.values());

      console.log("Step1: Sanitized Tradermarks: ", uniqueData);

      accolade.trademarks = uniqueData;
    });

    $(".step2Prev").click(function (event) {
      event.stopPropagation();

      // Remove multiple class
      $("#step2").removeClass("show active");
      $("#step1").addClass("show active");
      $("#step2tab").addClass("unable");
      $("#step3tab").addClass("unable");

      _resetRegionProducts();
      console.log(accolade);
    });

    $(".step2Next").click(function (event) {
      event.stopPropagation();

      // Remove multiple class
      $("#step2").removeClass("show active");
      $("#step3tab").removeClass("unable");
      $("#step3").addClass("show active");


      const trademarks = accolade.trademarks;
      trademarks.map((tm) => {
        tm.id = tm.id.split("_")[0];
        //* If the label has "-" then split it and take the second part otherwise take the first part
        if (tm.label.includes("-")) {
          tm.label = tm.label.split("-")[1].trim();
          accolade.quantity = accolade.trademarks.length;
        }

        accolade.quantity = accolade.trademarks.length;

        return (tm.label = tm.label);
      });

      console.log("Step2: Sanitized Tradermarks: ", trademarks);

      $("#step3Previous").removeClass("unable");
    });

    $(".selectRegion").on("change", function () {
      if ($(this).val() !== "") {
        $(".step2Next").removeClass("unable");
      } else {
        $(".step2Next").addClass("unable");
      }
    });

    $("#step3Previous").click(function (event) {
      event.stopPropagation();

      $("#searchHistory").remove();

      // Remove multiple class
      $("#step3").removeClass("show active");
      $("#step3tab").addClass("unable");
      $("#step2").addClass("show active");
      $(".step2Prev").removeClass("unable");
      // $(".step2Next").addClass("unable");

      // _resetRegionProducts();
      console.log(accolade);
    });

    $("#word").click(function () {
      $(".trademark-type-word").removeClass("hide");
      $(".trademark-type-logo").addClass("hide");

      // Clear the logo file input
      $("#trademark_logo").val("");

      // Also uncheck the logo
      $("#logo").prop("checked", false);
      $("#both").prop("checked", false);
    });

    $("#logo").click(function () {
      $(".trademark-type-logo").removeClass("hide");
      $(".trademark-type-word").addClass("hide");

      // Clear the trademark_name input
      $("#trademark_name").val("");

      // Also uncheck the word
      $("#word").prop("checked", false);
      $("#both").prop("checked", false);
    });

    $("#both").click(function () {
      $(".trademark-type-word, .trademark-type-logo").removeClass("hide");

      // Also uncheck the word
      $("#word").prop("checked", false);
      $("#logo").prop("checked", false);
    });
  }

  function _resetRegionProducts() {
    const step2SelectedElem = $(
      "#cou-find .cou-selected, #cou-select .cou-selected"
    );
    const locations = $(".cou-items");

    $(step2SelectedElem).find("p.badge").remove();
    $(locations).find("label").removeClass("checked");

    accolade.locations = [];
    accolade.items = [];
    accolade.totalPrice = 0;

    $(".cou-search").val("");
    $(".cou-items label").show();

    $(".gs-search").val("");
    $(".gs-items p").show();

    $("#step1AutoComplete").hide();
    $("#step2AutoComplete").hide();

    console.log(accolade);
  }

  function _updatePillBtnStage() {
    const step1PillTabCount = $(".gs-selected p.badge").length;
    const step2PillTabCount = $(".cou-selected p.badge").length;

    if (step1PillTabCount === 0) $(".step1Next").addClass("unable");

    if (step2PillTabCount === 0) $(".step2Next").addClass("unable");
  }

  function _handlePillTabChanges() {
    let observer = new MutationObserver((mutationList) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          _updatePillBtnStage();
        }
      }
    });

    const config = {
      childList: true,
    };

    $(".gs-selected, .cou-selected").each(function () {
      observer.observe(this, config);
    });
  }



  _simpleUIStuff();
  _handlePillTabChanges();
});

// function currencyTextfn(cur){
//   if(window.location.href.split("/")[3].split("-")[1] === `${cur}`){
//     document.querySelector('#menu-click .currency').innerHTML = `${cur}`
//     console.log(`${cur}`)
//   }
// }
// var acur = ["aud","nzd","cad","eur","gbp","hk"]
// for (let i = 0; i < acur.length; i++) {
//   currencyTextfn(acur[i])
// }

